import moment from 'moment';
import { DAYS } from './constants';

export const priceFormatter = (amount, buyable, itemPurchaseVAT) => {
  if (buyable) {
    const vat = (amount * itemPurchaseVAT) / 100;
    amount = amount + vat;
  }
  const amountInDollar = amount / 100;
  const formattedAmount = amountInDollar?.toFixed(2);
  return formattedAmount?.endsWith('.00') ? formattedAmount?.replace('.00', '') : formattedAmount;
};

export const formatDateMonthDay = () => {
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  const currentDate = new Date();
  return currentDate.toLocaleDateString('en-US', options);
};

export const formatDate = date => {
  return new Date(date)
    .toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
    .replace(/ /g, '-');
};

export function dateFormatter(date) {
  const formattedDate = moment(date).format('MMMM DD, YYYY');
  return formattedDate;
}

export function dateFormatterSeparateWithDost(date) {
  const formattedDate = moment(date, 'YYYY-MM-DD').format('MM.DD.YYYY');
  return formattedDate;
}
export function dateFormatterHalfMonth(date) {
  const formattedDate = moment(date).format('MMM DD, YYYY');

  return formattedDate;
}

export function timeFormatter(date) {
  const formattedDate = moment(date).format('hh:mm A');

  return formattedDate;
}

export function dateTimeFullFormatter(date) {
  const formattedDate = moment(date).format('MMMM DD, YYYY hh:mm a');

  return formattedDate;
}

export function firstLetterCapitalized(word) {
  if (!word) return '';

  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export function acceptFormatter(word) {
  if (word.toLowerCase() === 'accepted') {
    return 'active';
  }
  if (word.toLowerCase() === 'lead') {
    return 'Lead';
  }
  return word;
}

export const getMediaType = fileType => {
  return fileType.split('/')[0];
};

export const formatWorkingHours = data => {
  let formattedDays = [];
  for (const day of DAYS) {
    let splitOpen = data[day.id + '_1_open'] && convertTime12to24(data[day.id + '_1_open']);
    let splitClose = data[day.id + '_1_close'] && convertTime12to24(data[day.id + '_1_close']);

    if (splitOpen) {
      const formattedDay = {
        daysOfWeek: [day.number],
        startTime: splitOpen,

        endTime: splitClose,
      };

      formattedDays.push(formattedDay);
    } else {
      continue;
    }
  }
  return formattedDays;
};

export const convertTime12to24 = time12h => {
  const [time, modifier] = time12h.split(' ');

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
};

// export const isValidPassword = password => {
//   const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&;,.:])[A-Za-z\d@$!%*?&;,.:]{8,}$/;
//   return passwordRegex.test(password);
// };

export const isValidPassword = password => {
  const oneUpperLetter = /(?=.*?[A-Z])/;
  const oneLowerLetter = /(?=.*?[a-z])/;
  const oneNumber = /(?=.*?[0-9])/;
  const oneSpecialCharacter = /(?=.*?[#?!@$%^&*-])/;
  const minLengthEight = /.{8,}/;

  return (
    oneUpperLetter.test(password) &&
    oneLowerLetter.test(password) &&
    oneNumber.test(password) &&
    oneSpecialCharacter.test(password) &&
    minLengthEight.test(password)
  );
};

export const blobUrlToFile = (blobUrl, fileName) => {
  return new Promise(function (resolve, reject) {
    fetch(blobUrl)
      .then(response => response.blob())
      .then(blobData => {
        resolve(new File([blobData], fileName, { type: 'image/jpeg' }));
      })
      .catch(error => {
        console.error('Error fetching blob data');
        reject();
      });
  });
};
